module.exports = __webpack_public_path__ + "img/filippo-galanti.76234429.jpg";